import { render, staticRenderFns } from "./RTabs.vue?vue&type=template&id=19495822&scoped=true"
import script from "./RTabs.vue?vue&type=script&lang=js"
export * from "./RTabs.vue?vue&type=script&lang=js"
import style0 from "./RTabs.vue?vue&type=style&index=0&id=19495822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19495822",
  null
  
)

export default component.exports